import type { Easing } from "motion";

// Sine easing functions
export const easeInSine: Easing = [0.12, 0, 0.39, 0];
export const easeOutSine: Easing = [0.61, 1, 0.88, 1];
export const easeInOutSine: Easing = [0.37, 0, 0.63, 1];

// Quad easing functions
export const easeInQuad: Easing = [0.11, 0, 0.5, 0];
export const easeOutQuad: Easing = [0.5, 1, 0.89, 1];
export const easeInOutQuad: Easing = [0.45, 0, 0.55, 1];

// Cubic easing functions
export const easeInCubic: Easing = [0.32, 0, 0.67, 0];
export const easeOutCubic: Easing = [0.33, 1, 0.68, 1];
export const easeInOutCubic: Easing = [0.65, 0, 0.35, 1];

// Quart easing functions
export const easeInQuart: Easing = [0.5, 0, 0.75, 0];
export const easeOutQuart: Easing = [0.25, 1, 0.5, 1];
export const easeInOutQuart: Easing = [0.76, 0, 0.24, 1];

// Quint easing functions
export const easeInQuint: Easing = [0.64, 0, 0.78, 0];
export const easeOutQuint: Easing = [0.22, 1, 0.36, 1];
export const easeInOutQuint: Easing = [0.83, 0, 0.17, 1];

// Expo easing functions
export const easeInExpo: Easing = [0.7, 0, 0.84, 0];
export const easeOutExpo: Easing = [0.16, 1, 0.3, 1];
export const easeInOutExpo: Easing = [0.87, 0, 0.13, 1];

// Circ easing functions
export const easeInCirc: Easing = [0.55, 0, 1, 0.45];
export const easeOutCirc: Easing = [0, 0.55, 0.45, 1];
export const easeInOutCirc: Easing = [0.85, 0, 0.15, 1];

// Back easing functions
export const easeInBack: Easing = [0.36, 0, 0.66, -0.56];
export const easeOutBack: Easing = [0.34, 1.56, 0.64, 1];
export const easeInOutBack: Easing = [0.68, -0.6, 0.32, 1.6];
